import MapSearch from '../search-map';
import { closeAllUtilityPopups, closeSideNav, openUtilityPopup } from '../../popups/utils';
import { getHTML, getUtilityPopupContainer } from '../../popups/utility-popups';

class InfoPopup {
    _mapSearch: MapSearch;
    _map: mapboxgl.Map;
    _container: HTMLElement;
    _openBtn: HTMLButtonElement;
    _closeBtn: HTMLButtonElement | null;
    _popup: HTMLElement | null;

    constructor( mapSearch: MapSearch ) {
        this._mapSearch = mapSearch;
        this._popup = document.querySelector<HTMLButtonElement>( '.popup__container--mapinfo' );
        this._closeBtn = document.querySelector<HTMLButtonElement>( '.popup__container--mapinfo .popup__close' );
    }

    onAdd( map: mapboxgl.Map ) {
        this._map = map;

        this._initPopup();

        this._container = document.createElement( 'div' );
        this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group mapinfo__container';

        this._openBtn = document.createElement( 'button' );
        this._openBtn.type = 'button';
        this._openBtn.className = 'twc__map-search-item mapinfo__btn';
        this._openBtn.title = this._mapSearch.getTemplateString( 'infoPopupBtnOpen', [] );
        this._openBtn.addEventListener( 'click', this._open.bind( this ) );

        this._container.appendChild( this._openBtn );

        return this._container;
    }

    async _open(): Promise<void> {
        if ( !this._popup ) {
            const popupContainer = getUtilityPopupContainer();
            this._popup = await getHTML( 'map-info-popup' );
            popupContainer.appendChild( this._popup );
        }

        this._initPopup();

        await closeSideNav();

        closeAllUtilityPopups( false );

        openUtilityPopup( this._popup );
    }

    _initPopup(): void {
        this._closeBtn = document.querySelector<HTMLButtonElement>( '.popup__container--mapinfo .popup__close' );

        if ( this._closeBtn ) {
            this._closeBtn.addEventListener( 'click', this._close.bind( this ) );
        }
    }

    _close( event: Event ): void {
        closeAllUtilityPopups( true );
    }
}

export default InfoPopup;
